// Cliente axios + endpoints del modulo Usuarios (roles y permisos).
// Sigue el mismo patron liviano que pacientesApi.js / catalogosApi.js: sin
// redux, cada pagina llama directo a estas funciones y guarda el resultado
// en estado local. El interceptor de sesion global (redux/axiosSetup.js) ya
// esta parcheado sobre axios.create, asi que esta instancia hereda el manejo
// de token vencido / refresh sin configuracion adicional.
//
// Estos endpoints exigen rol "Administrador" en el backend (403 si no lo
// es). La UI se encarga de mostrar un mensaje de acceso restringido en vez
// de intentar cargar cuando el usuario logueado no es Administrador (ver
// UsuariosPage.jsx).
import axios from "axios";
import { PATH } from "../../redux/utils";

export const apiUsuarios = axios.create({ baseURL: PATH });

export const authHeaderUsuarios = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const H = () => ({ headers: authHeaderUsuarios() });

export const getRolActual = () => localStorage.getItem("role") || "";
export const esAdministrador = () => String(getRolActual() || "").toLowerCase() === "administrador";

// ---------------------------------------------------------------------
// Usuarios
// ---------------------------------------------------------------------
export const getUsuarios = () => apiUsuarios.get("/usuarios", H());
export const getUsuario = (id) => apiUsuarios.get(`/usuarios/${id}`, H());
export const crearUsuario = (payload) => apiUsuarios.post("/usuarios", payload, H());
export const editarUsuario = (id, payload) => apiUsuarios.put(`/usuarios/${id}`, payload, H());
export const resetPasswordUsuario = (id, payload) =>
  apiUsuarios.post(
    `/usuarios/${id}/reset-password`,
    { new_password: payload?.new_password ?? payload?.password },
    H()
  );

// ---------------------------------------------------------------------
// Permisos por usuario
// ---------------------------------------------------------------------
export const getPermisosUsuario = (id) => apiUsuarios.get(`/usuarios/${id}/permisos`, H());
// `puedeSolicitarCambios` (boolean) es el permiso especial; undefined = no cambiarlo.
export const putPermisosUsuario = (id, permisos, puedeSolicitarCambios) =>
  apiUsuarios.put(
    `/usuarios/${id}/permisos`,
    { permisos, ...(puedeSolicitarCambios === undefined ? {} : { puede_solicitar_cambios: puedeSolicitarCambios }) },
    H()
  );

// ---------------------------------------------------------------------
// Roles
// ---------------------------------------------------------------------
export const getRoles = () => apiUsuarios.get("/roles", H());
export const crearRol = (payload) => apiUsuarios.post("/roles", payload, H());
export const editarRol = (id, payload) => apiUsuarios.put(`/roles/${id}`, payload, H());
